
export class Product {
    id: string;
    name: string;
    description: string;
    price: string;
    mainImageUrl: string;
}

function Product_tsickle_Closure_declarations() {
/** @type {?} */
Product.prototype.id;
/** @type {?} */
Product.prototype.name;
/** @type {?} */
Product.prototype.description;
/** @type {?} */
Product.prototype.price;
/** @type {?} */
Product.prototype.mainImageUrl;
}
